import React from 'react';

const NAVY = '#002850';

function LoginPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f0f4f8',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif"
      }}>
      {/* Brand header */}
      <div style={{ textAlign: 'center', marginBottom: '28px' }}>
        <div style={{ color: NAVY, fontSize: '26px', fontWeight: '700', letterSpacing: '-0.3px' }}>
          Seven Advisors
        </div>
        <div style={{ color: '#64748b', fontSize: '13px', marginTop: '4px' }}>
          Project Calculus &mdash; Structured Products Platform
        </div>
      </div>

      {/* Maintenance notice */}
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 4px 24px rgba(0, 40, 80, 0.10)',
          padding: '36px 32px',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
        <div style={{ fontSize: '15px', fontWeight: '600', color: NAVY, marginBottom: '10px' }}>
          Temporarily unavailable
        </div>
        <div style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.6' }}>
          This application is currently offline for maintenance. Please check back soon.
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          marginTop: '28px',
          fontSize: '12px',
          color: '#94a3b8',
          textAlign: 'center'
        }}>
        &copy; {new Date().getFullYear()} Seven Advisors. Internal use only.
      </div>
    </div>
  );
}

export default LoginPage;
